module.exports = __webpack_public_path__ + "img/victor-lawson.366deadd.png";